import React from 'react';

export function TemplatesIcon({ size = 48 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        // eslint-disable-next-line max-len
        d="M36.6321 39.7953H11.4321C10.8114 39.7953 10.1967 39.673 9.62317 39.4355C9.04966 39.1979 8.52855 38.8497 8.0896 38.4108C7.65065 37.9718 7.30246 37.4507 7.0649 36.8772C6.82735 36.3037 6.70508 35.689 6.70508 35.0682V9.85178H19.3051L23.9992 16.16H41.3592V35.0682C41.3592 35.689 41.2369 36.3037 40.9994 36.8772C40.7618 37.4507 40.4136 37.9718 39.9747 38.4108C39.5357 38.8497 39.0146 39.1979 38.4411 39.4355C37.8676 39.673 37.2529 39.7953 36.6321 39.7953Z"
        stroke="#6255AE"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M24.0312 9.85178H42.9395" stroke="#6255AE" strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  );
}
